import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccessManagementService } from '@libs/portal-common/services';
import { daysOfWeek, kendoMultiSelectTagMapper } from '@libs/portal-common/shared';
import { ContactsService } from '@libs/portal-common/services';
import { LocationsService } from '@libs/portal-common/services';
import { ActivityFilter } from '../services/call-history.service';

@Component({
  selector: 'app-activity-filter',
  templateUrl: './activity-filter.component.html',
  styleUrls: ['./activity-filter.component.scss'],
})
export class ActivityFilterComponent implements OnInit {
  @Input() mode: string;

  @Input() filter: ActivityFilter;

  @Input() disabled = false;

  days = [];

  locations = [];
  filteredLocations = [];

  agents = [];
  filteredAgents = [];

  skypeAgentEmail = '';

  displayLocations = false;
  displayAgents = false;
  public tagMapper = kendoMultiSelectTagMapper;

  @Output() search = new EventEmitter<ActivityFilter>();

  constructor(
    private locationsService: LocationsService,
    private contactsService: ContactsService,
    private accessManagementService: AccessManagementService,
  ) {
    this.days = daysOfWeek;
  }

  handleDaysFilter(value) {
    this.days = daysOfWeek.filter((s) => s.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleLocationsFilter(value: string): void {
    if (!value) {
      this.filteredLocations = [...this.locations];
      return;
    }

    const searchTerm = value.toLowerCase();

    this.filteredLocations = this.locations.filter((s) =>
      s.LotName.toLowerCase().includes(searchTerm)
    );
  }

  handleAgentsFilter(value) {
    this.filteredAgents = this.agents.filter((s) => s.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  ngOnInit() {
    if (this.accessManagementService.hasAccessPermissions({ entities: ['Locations'], access: 'CanRead' })) {
      this.displayLocations = true;
      this.locationsService.getAll().subscribe((response) => {
        this.locations = (response.Data || []).map(function (lot) {
          return {
            Id: lot.Id,
            LotName: `${lot.LotNumber} ${lot.LotName}`,
            Archived: lot.Archived,
            Disabled: !lot.Active,
          };
        });

        this.filteredLocations = this.locations;
      });
    }

    if (this.accessManagementService.hasAccessPermissions({ entities: ['Locations'], access: 'CanRead' })) {
      this.displayAgents = true;
      this.contactsService.getAgents().subscribe((response) => {
        this.agents = (response.Data || []).map(function (agent) {
          return {
            Id: agent.Id,
            SIP: agent.SipAddress,
            Name: agent.Name,
          };
        });

        this.filteredAgents = this.agents;
      });
    }
  }

  searchClick() {
    this.search.emit(this.filter);
  }

  toggleRandomSample(enabled: boolean) {
    this.filter.RandomSampleEnabled = enabled;
  }

  resetFilter() {
    this.filter = new ActivityFilter();
    this.search.emit(this.filter);
  }

  isLocationSelected(id: number): boolean {
    return this.filter.LotIds && this.filter.LotIds.includes(id);
  }
}
